module.exports = __webpack_public_path__ + "static/media/11_tn.a9673d3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/11_tn.jpg
// module id = 320
// module chunks = 0